import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import useQuery from '_hooks/useQuery'
import useUserRole from '_hooks/useUserRole'
import useBodyClass from '_hooks/useBodyClass'
import useViewMode, { VIEW_MODES } from '_hooks/useViewMode'
import { getGroupWithEventById } from '_redux/modules/group'
import EventCard from '_components/EventCard'
import GroupHeader from './components/GroupHeader'
import FilterBar from './components/FilterBar'
import useFilterBar from './hooks/useFilterBar'
import './style.scss'

export default function GroupDetail() {
  useBodyClass('group-detail-page')
  const dispatch = useDispatch()
  const history = useHistory()
  const params = useQuery()
  const groupId = params.get('groupId')

  const [isLoading, setIsLoading] = useState(false)
  const { groupById = {} } = useSelector((state) => state.group)
  const { viewMode, changeViewMode, isList } = useViewMode({
    storageKey: 'group_detail_view_mode',
    initialMode: VIEW_MODES.TILE,
  })
  const { isAdmin } = useUserRole(groupById)

  const { filteredEvents, filterBarProps } = useFilterBar(groupById?.events || [])

  useEffect(() => {
    if (!groupId) return
    const fetchGroup = async () => {
      setIsLoading(true)
      await dispatch(getGroupWithEventById(groupId))
      setIsLoading(false)
    }
    fetchGroup()
  }, [groupId, dispatch])

  const handleCardClick = (event) => {
    if (event?.id) {
      history.push(`/event/detail?eid=${event.id}`)
    }
  }

  const eventsList = filteredEvents

  if (isLoading) {
    return (
      <div style={{ padding: '24px', textAlign: 'center', color: '#888780' }}>
        Loading group detail...
      </div>
    )
  }

  return (
    <div className="group-detail">
      <GroupHeader groupId={groupId} groupById={groupById} isAdmin={isAdmin} />
      <FilterBar
        filterBarProps={filterBarProps}
        viewMode={viewMode}
        changeViewMode={changeViewMode}
      />

      <div className="gd-events">
        {/* List view or Grid view */}
        {eventsList.length === 0 ? (
          <div style={{ padding: '32px 14px', textAlign: 'center', color: '#888780', fontSize: '13px' }}>
            No events found.
          </div>
        ) : isList ? (
          <div className="feed">
            {eventsList.map((item) => (
              <EventCard
                key={item.id}
                event={item}
                viewMode={VIEW_MODES.LIST}
                onCardClick={handleCardClick}
              />
            ))}
          </div>
        ) : (
          <div className="mef-grid">
            {eventsList.map((item) => (
              <EventCard
                key={item.id}
                event={item}
                viewMode={VIEW_MODES.TILE}
                onCardClick={handleCardClick}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
